import React from "react";
import PropTypes from "prop-types";
import { Button } from "cxa-components";
// import { range } from "cxa-utils";
import HeaderForm from "../common/HeaderForm";
import Employee from "./Employee";
import Family from "./Family";
import Dependent from "./Dependent";
import Habit from "./Habit";
import Health from "./Health";
import Details from "./Details";
import DataProtection from "./DataProtection";
import Declaration from "./Declaration";
import Signature from "./Signature";
import Footer from "../common/Footer";
import { SUBMIT_FAILURE_MESSAGE } from "../../constants";
import "~/scss/RHI.scss";

const formName = "PERSONAL HEALTH DECLARATION FORM";

const Form = ({ data, isReadOnly, onClose, onPrint, onSave, submitting, submitFailed }) => {
  return (
    <div className="rhi-hdf">
      <HeaderForm {...{ formName, data }} />
      <Employee data={data} />
      <Family data={data} />
      <Dependent data={data} />
      <Habit data={data} />
      <Health data={data} />
      <Details data={data} />
      <DataProtection data={data} />
      <br />
      <Declaration />
      <Signature data={data} />
      <Footer />

      {submitFailed && (
        <p role="alert" className="card--alert">
          {SUBMIT_FAILURE_MESSAGE}
        </p>
      )}

      <p>
        {!isReadOnly ? (
          <React.Fragment>
            <Button type="button" onClick={onSave} disabled={submitting} secondary>
              Save
            </Button>
            <Button primary type="submit" submitting={submitting} disabled={submitting}>
              Submit & Confirm
            </Button>
          </React.Fragment>
        ) : (
          <Button primary type="button" onClick={onPrint}>
            Print
          </Button>
        )}

        <Button onClick={onClose} disabled={submitting} secondary>
          Close
        </Button>
      </p>
    </div>
  );
};

Form.propTypes = {
  submitFailed: PropTypes.bool.isRequired,
  submitSucceeded: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onPrint: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  isReadOnly: PropTypes.bool,
  data: PropTypes.object,
};

export default Form;



// WEBPACK FOOTER //
// ./components/employee/hdf_forms/RHI/RHIHD201907/index.jsx